import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

const ScrollToTop = () => {
  return( 
  <>
      <button className="scroltop"><span className="fa fa-angle-up  relative" id="btn-vibrate"></span></button>
  </>
  );
};

export default ScrollToTop;